export const TAB_INDEX = {
  on: 0,
  off: -1
} as const

export const KEYS = {
  space: ' '
} as const

export * from './dateFormat'
export * from './queryParams'

export { SIZE } from './size'
export { ICON_SIZE } from './button'
export { BUTTON_TYPE } from './button'
export { TABLE_ROW_COLORS } from './table'
